import { render, staticRenderFns } from "./CustomizeMetalD.vue?vue&type=template&id=65b896aa&scoped=true"
import script from "./CustomizeMetalD.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalD.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalD.vue?vue&type=style&index=0&id=65b896aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b896aa",
  null
  
)

export default component.exports